import { useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import styles from "./styles.module.css";

const ThemeToggle = () => {
  const [theme, changeTheme] = useContext(ThemeContext);
  const [I18n] = useContext(LanguageContext);
  const isDark = theme === "dark";

  const handleToggle = () => {
    const next = isDark ? "light" : "dark";
    changeTheme(next);
    triggerLogEvent(analytics, "setting_appearance_theme_saved", { theme: next });
  };

  return (
    <button
      type="button"
      id="header_theme_toggle"
      className={`${styles.themeToggle} ${isDark ? styles.themeToggleDark : ""}`}
      onClick={handleToggle}
      aria-pressed={isDark}
      aria-label={isDark ? I18n.light_mode : I18n.dark_mode}
    >
      <span className={styles.themeThumb} />
      <span className={styles.themeStarsLight} aria-hidden="true">
        <span className={styles.themeSparkle} />
        <span className={styles.themeDot} />
        <span className={styles.themeDotSecondary} />
      </span>
      <span className={styles.themeMoonFace} aria-hidden="true">
        <span className={styles.themeCrescent} />
        <span className={`${styles.themeCrater} ${styles.themeCraterOne}`} />
        <span className={`${styles.themeCrater} ${styles.themeCraterTwo}`} />
        <span className={`${styles.themeCrater} ${styles.themeCraterThree}`} />
      </span>
    </button>
  );
};

export default ThemeToggle;
